import script from "./empower.vue?vue&type=script&setup=true&lang=js"
export * from "./empower.vue?vue&type=script&setup=true&lang=js"

import "./empower.vue?vue&type=style&index=0&id=6e426160&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e426160"]])

export default __exports__